import { PARTY_COLORS, PARTY_LABELS } from '../constants/appConfig';

export const getPartyColor = (party) => {
    return PARTY_COLORS[party] || PARTY_COLORS.default;
};

export const getPartyLabel = (party) => {
    return PARTY_LABELS[party] || party;
};

export const getGenderIcon = (gender) => {
    return gender === 'M' ? '♂️' : gender === 'F' ? '♀️' : '';
};

export const formatTermEnd = (termEnd) => {
    return termEnd ? `Term ends: ${termEnd}` : 'Term end date not available';
};

export const getOfficialWebsiteLink = (official, fallbackUrl) => {
    return official.website || fallbackUrl;
};

export const getOfficialDisplayInfo = (official, showAge = true, showGender = true) => {
    const parts = [];
    
    if (showAge && official.age) {
        parts.push(`Age: ${official.age}`);
    }
    
    if (showGender && official.gender) {
        parts.push(getGenderIcon(official.gender));
    }
    
    return parts.join(' • ');
};